/** The golden spec's tags, which the generated query keys carry for invalidation. */
export const GOLDEN_TAGS = {
  cases: ["golden", "cases"],
  runs: ["golden", "runs"],
  documents: ["golden", "documents"],
  reviews: ["golden", "reviews"],
  corrections: ["golden", "corrections"],
  testGroups: ["golden", "test-groups"],
} as const;
